import { ModelBase } from 'store/model-base';

import { QuickpayEmailNotificationStatus } from 'my-account/constants';

export class QuickpaymentResult extends ModelBase {
    public static storeName: string = 'quickpaymentResult';

    public state: string;
    public amount: number;
    public paymentId: string;
    public authResponseCode: string;
    public ccLastFour: string;
    public ccType: string;
    public oneTimeEmailId: string;
    public notificationStatus: QuickpayEmailNotificationStatus;

    public emailSuccess: boolean;
    public emailNotApplicable: boolean;
    public emailFailure: boolean;

    public static create<T extends ModelBase>(data: ApiResponse = {}): T {
        data.emailSuccess = data.notificationStatus === QuickpayEmailNotificationStatus.SUCCESS;
        data.emailNotApplicable = !data.oneTimeEmailId || data.notificationStatus === QuickpayEmailNotificationStatus.NA;
        data.emailFailure = data.oneTimeEmailId && data.notificationStatus === QuickpayEmailNotificationStatus.FAILURE;

        return super.create<T>(data);
    }
}
